(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const toggleHoverDetails = (detailsSelector) => {
    const detailItems = document.querySelectorAll(detailsSelector);

    detailItems.forEach((details) => {
      let timeout;

      const summary = details.querySelector('summary');

      if (summary) {
        summary.addEventListener('click', (e) => {
          const url = summary.getAttribute('data-url');

          if (url) {
    e.preventDefault(); // Only prevent default if navigating
    window.location.href = url;
  }
        });
      }

      details.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
        details.setAttribute('open', true);
      });

      details.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          // Add closing class for fade-out transition
          details.classList.add('mega-menu--closing');
          
          // Remove open attribute after transition completes
          setTimeout(() => {
            details.removeAttribute('open');
            details.classList.remove('mega-menu--closing');
          }, 300); // Match CSS transition duration
        }, 500);
      });
    });
  };

  toggleHoverDetails('.menu-toggle-selector'); // Top-level
  toggleHoverDetails('.mega-menu-sub');        // Second-level
});
  } catch(e) { console.error(e); }
})();

})();
